/*  eslint-disable */
import React from 'react';

import DataSecurity from '../../../resources/ExperienceCards/DataSecurityPhoto.jpg';
import WholeHomeBackup from '../../../resources/ExperienceCards/WholeHomeBackup.jpg';
import EntertainmentStreaming from '../../../resources/ExperienceCards/EntertainmentStreaming.jpg';
import ParentalControl from '../../../resources/ExperienceCards/ParentalControls.jpg';
import WifiEval from '../../../resources/ExperienceCards/WifiEval.jpg';
import ProductSetup from '../../../resources/ExperienceCards/ProductSetup.jpg';
import ProductPurchase from '../../../resources/ExperienceCards/ProductPurchase.jpg';
import PasswordManagement from '../../../resources/ExperienceCards/PasswordManagement.jpg';
import CustomAppt from '../../../resources/ExperienceCards/CustomAppt.jpg';

import NewStreamingDeviceIcon from '../../../resources/react-svg/NewStreamingDeviceIcon.js';
import Alexa from '../../../resources/react-svg/Alexa.js';
import TVWithRemote from '../../../resources/react-svg/TVwithRemote.js';
import WiFi from '../../../resources/react-svg/Wi-Fi.js';
import AlarmSystem from '../../../resources/react-svg/AlarmSystem.js';
import Backup from '../../../resources/react-svg/Backup.js';
import Computer1 from '../../../resources/react-svg/Computer1.js';
import Controller from '../../../resources/react-svg/Controller.js';
import Devices from '../../../resources/react-svg/Devices.js';
import LocationIcon from '../../../resources/react-svg/locationicon.js';
import OutsideCamera from '../../../resources/react-svg/OutsideCamera.js';
import SHSIconUser from '../../../resources/react-svg/SHS_Icons_user.js';
import NestTermostat from '../../../resources/react-svg/NestTermostat.js';
import SecurityCamera from '../../../resources/react-svg/SecurityCamera.js';
import FitnessTracker from '../../../resources/react-svg/FitnessTracker.js';
import Chromecast from '../../../resources/react-svg/Chromecast.js';
import Echo from '../../../resources/react-svg/Echo.js';
import Group2Dot2 from '../../../resources/react-svg/Group2.2.js';
import Cal from '../../../resources/react-svg/Cal.js';
import Headphones from '../../../resources/react-svg/Headphones.js';
import TVandRemote from '../../../resources/react-svg/TVandRemote.js';
import PhoneAndLaptop from '../../../resources/react-svg/PhoneAndLaptop.js';
import Desktop from '../../../resources/react-svg/Desktop.js';
import config from '../../../config/config';
import { megaUseCases } from '../../../config/megaUseCases';
import { theme } from '../../../../../themes';
import SafeConsole from '../../../util/ConsoleUtils';

const CustomerSay = (
  <div>
    <p>
      “This is the best service i’ve ever purchased. My home is completely automated and I couldn’t have done it without
      SHS help, thank you!” - Katherine Martinez
    </p>
    <br />
    <p>
      “I wasn’t sure where to start but the Smart Home Expert Carey helped me understand what some of the options to fit
      my needs were and walked me through where to start, he then set up a separate session with me to help me connect
      everything and followed up later on to make sure it was all working, truly exceptional service.” - Gabe
      Pattenhouse
    </p>
  </div>
);

const DataSecurityPoints = {
  items: [
    {
      key: 1,
      svg: WiFi,
      text: 'Securing up your home Wi-Fi network and practicing smart browsing habits',
    },
    {
      key: 2,
      svg: OutsideCamera,
      text: 'Learning how to spot malware and phishing scams',
    },
    {
      key: 3,
      svg: AlarmSystem,
      text: 'Learning how to freeze your credit to prevent ID theft',
    },
    {
      key: 4,
      svg: Computer1,
      text: 'Staying informed about the latest breaches and assessing your risk',
    },
  ],
};

const DataBackupPoints = {
  items: [
    {
      key: 1,
      svg: Devices,
      text: 'Creating cloud backups and syncing data across your devices',
    },
    {
      key: 2,
      svg: Computer1,
      text: 'Checking your existing backups for issues',
    },
    {
      key: 3,
      svg: LocationIcon,
      text: 'Combining multiple backup services into one central location',
    },
    {
      key: 4,
      svg: Backup,
      text: 'Reviewing the latest backup tools',
    },
  ],
};

const StreamingAndEntertainmentPoints = {
  items: [
    {
      key: 1,
      svg: NewStreamingDeviceIcon,
      text: 'Choose new streaming devices and set them up',
    },
    {
      key: 2,
      svg: TVWithRemote,
      text: 'Connect your streaming device to other smart tech around the house',
    },
    {
      key: 3,
      svg: WiFi,
      text: 'Speed up your Wi-Fi connection',
    },
    {
      key: 4,
      svg: Alexa,
      text: 'Use your phone or a virtual assistant (like Alexa) as a remote control',
    },
  ],
};

const HomeParentalControlPoints = {
  items: [
    {
      key: 1,
      svg: Computer1,
      text: 'Limit access to websites and see how long your kids are online',
    },
    {
      key: 2,
      svg: SHSIconUser,
      text: 'Adjust your browser settings and set up safe streaming profiles',
    },
    {
      key: 3,
      svg: Controller,
      text: 'Monitor streaming content, and even video games',
    },
  ],
};

const ProductSetupAndFeatureOverviewPoints = {
  items: [
    {
      key: 1,
      svg: Group2Dot2,
      text: 'Providing advice for optimizing your devices to the way you want to use them',
    },
    {
      key: 2,
      svg: Chromecast,
      text: 'Raise awareness of features you may not have considered',
    },
    {
      key: 3,
      svg: TVandRemote,
      text: 'Making sure you’re set up for success when using your products',
    },
  ],
};

const PasswordManagementPoints = {
  items: [
    {
      key: 1,
      svg: Desktop,
      text: 'Discussing password and security best practices',
    },
    {
      key: 2,
      svg: PhoneAndLaptop,
      text: 'Teaching you about tools that you can use to safely manage your passwords',
    },
    {
      key: 3,
      svg: TVandRemote,
      text: 'Set up your log-ins so you don’t have to worry about remembering anymore passwords',
    },
  ],
};

const ProductPurchaseGuidancePoints = {
  items: [
    {
      key: 1,
      svg: Headphones,
      text: 'Listening to your specific needs',
    },
    {
      key: 2,
      svg: Chromecast,
      text: 'Making sure you are aware of all the options available to you',
    },
    {
      key: 3,
      svg: TVandRemote,
      text: 'Providing expert advice on which products will best suit your needs',
    },
    {
      key: 4,
      svg: Cal,
      text: 'Offering to arrange a follow-up session to help you get set up for success with any new product',
    },
  ],
};

const WiFiEvaluationPoints = {
  items: [
    {
      key: 1,
      svg: Group2Dot2,
      text: 'Reviewing your hardware and making sure it’s set up correctly',
    },
    {
      key: 2,
      svg: Chromecast,
      text: 'Evaluating your service plan, to make sure you’re getting exactly what you need',
    },
    {
      key: 3,
      svg: Echo,
      text: 'Advising you on optimizing your home Wi-Fi ecosystem',
    },
  ],
};

const CustomAppointmentPoints = {
  items: [
    {
      key: 1,
      svg: SecurityCamera,
      text: 'General troubleshooting on any device',
    },
    {
      key: 2,
      svg: NestTermostat,
      text: 'Setting up new devices and making sure you get the most your technology has to offer',
    },
    {
      key: 3,
      svg: FitnessTracker,
      text: 'Expert advice on smart home technology',
    },
  ],
};

const pointsStyles = { color: theme.colors.primaryAccentOnWhite, width: '30px', height: '30px' };

const SHS_WEB_experiencesDataArray = {
  version: 2,
  experiencesTitle: 'Expert Sessions',
  popularExperiencsTitle: 'Popular Smart Home Expert Sessions',
  data: [
    {
      category: 'Security',
      megaUseCase: megaUseCases.securityprivacy,
      vhtSegment: undefined,
      isPopular: true,
      tile: {
        title: 'Data Security and Privacy',
        text:
          'We want you to feel confident and secure as you use all of the devices in your home. The digital world holds no shortage of security and privacy threats, but there are practical steps you can take to stay safe.',
        imageSrc: DataSecurity,
      },
      details: {
        title: 'Data Security and Privacy',
        text: (
          <div>
            We want you to feel confident and secure as you use all of the devices in your home. The digital world holds
            no shortage of security and privacy threats, but there are practical steps you can take to stay safe.
            <br />
            <br />
            <p style={{ fontSize: '24px', fontWeight: '600', lineHeight: '31px' }}>
              In this one-on-one Expert Session, we’ll show you how to safeguard your smart tech and online accounts by:
            </p>
            <br />
            {DataSecurityPoints.items.map((item) => {
              return (
                <div className="points" key={item.key}>
                  <div className="points__svg">{item.svg(pointsStyles)}</div>
                  <p>{item.text}</p>
                </div>
              );
            })}
            <br />
            <p
              style={{
                fontWeight: '600',
                fontSize: '24px',
                color: '333333',
                lineHeight: '31px',
              }}
            >
              Ready to learn more?
            </p>
            <br />
            Sign up for an Expert Session on Data Security and Privacy.
          </div>
        ),
        testimonials: [
          {
            text: CustomerSay,
          },
        ],
        imageSrc: DataSecurity,
      },
      bookingModal: {
        title: 'Schedule Your Data Security and Privacy Review',
      },
    },
    {
      category: 'Digital Life',
      megaUseCase: megaUseCases.databackup,
      vhtSegment: undefined,
      isPopular: true,
      tile: {
        title: 'Whole Home Data Backup',
        text:
          'It’s important to keep all of your data backed up, no matter where you store it - whether that’s on a laptop, a tablet, a memory card full of photos, or a smartphone.',
        imageSrc: WholeHomeBackup,
      },
      details: {
        title: 'Whole Home Data Backup',
        text: (
          <div>
            It’s important to keep all of your data backed up, no matter where you store it - whether that’s on a
            laptop, a tablet, a memory card full of photos, or a smartphone.
            <br />
            <br />
            <p style={{ fontSize: '24px', fontWeight: '600', lineHeight: '31px' }}>
              In this Expert Session, we’ll teach you how to safely store and sync your data by:
            </p>
            <br />
            {DataBackupPoints.items.map((item) => {
              return (
                <div className="points" key={item.key}>
                  <div className="points__svg">{item.svg(pointsStyles)}</div>
                  <p>{item.text}</p>
                </div>
              );
            })}
            <br />
            <p
              style={{
                fontWeight: '600',
                fontSize: '24px',
                color: '333333',
                lineHeight: '31px',
              }}
            >
              Ready to learn more?
            </p>
            <br />
            Sign up for an Expert Session on Whole Home Data Backup and Syncing.
          </div>
        ),
        testimonials: [
          {
            text: CustomerSay,
          },
        ],
        imageSrc: WholeHomeBackup,
      },
      bookingModal: {
        title: 'Schedule Your Whole Home Data Backup Consultation',
      },
    },
    {
      category: 'Security',
      megaUseCase: megaUseCases.streamingentertainment,
      vhtSegment: undefined,
      isPopular: true,
      tile: {
        title: 'Streaming and Entertainment',
        text:
          'Enjoying your favorite shows, movies, and music is easy to do with the right technology in your home. But with so many streaming options to choose from - Chromecast, Roku, Fire TV, Apple TV—it can be difficult to know where to start.',
        imageSrc: EntertainmentStreaming,
      },
      details: {
        title: 'Streaming and Entertainment',
        text: (
          <div>
            Enjoying your favorite shows, movies, and music is easy to do with the right technology in your home. But
            with so many streaming options to choose from - Chromecast, Roku, Fire TV, Apple TV—it can be difficult to
            know where to start.
            <br />
            <br />
            <p className="tertiaryHeadingFonts" style={{ lineHeight: '31px' }}>
              Our team can help. In this one-on-one Expert Session, we’ll show you how to:
            </p>
            <br />
            {StreamingAndEntertainmentPoints.items.map((item) => {
              return (
                <div className="points" key={item.key}>
                  <div className="points__svg">{item.svg(pointsStyles)}</div>
                  <p>{item.text}</p>
                </div>
              );
            })}
            <br />
            <p
              className="tertiaryHeadingFonts"
              style={{
                color: '333333',
                lineHeight: '31px',
              }}
            >
              Ready to learn more?
            </p>
            <br />
            Sign up for an Expert Session on Streaming and Entertainment.
          </div>
        ),
        testimonials: [
          {
            text: CustomerSay,
          },
        ],
        imageSrc: EntertainmentStreaming,
      },
      bookingModal: {
        title: 'Schedule Your Streaming and Entertainment Setup',
      },
    },
    {
      category: 'Digital Life',
      megaUseCase: megaUseCases.parentalcontrol,
      vhtSegment: undefined,
      isPopular: true,
      tile: {
        title: 'Connected Home & Parental Control',
        text:
          'Flat screen TVs, smartphones, computers and gaming consoles - with so many different screens in your home, it’s hard to keep track of who’s using each one and what they’re using it for. Manage content across your devices with a few tweaks to your parental controls.',
        imageSrc: ParentalControl,
      },
      details: {
        title: 'Connected Home & Parental Control',
        text: (
          <div>
            Flat screen TVs, smartphones, computers and gaming consoles - with so many different screens in your home,
            it’s hard to keep track of who’s using each one and what they’re using it for. Manage content across your
            devices with a few tweaks to your parental controls.
            <br />
            <br />
            <p style={{ fontSize: '24px', fontWeight: '600', lineHeight: '31px' }}>
              Our team can help you get started. In this one-on-one Expert Session, you’ll learn how to:
            </p>
            <br />
            {HomeParentalControlPoints.items.map((item) => {
              return (
                <div className="points" key={item.key}>
                  <div className="points__svg">{item.svg(pointsStyles)}</div>
                  <p>{item.text}</p>
                </div>
              );
            })}
            <br />
            <p>
              You’ll feel confident knowing the technology in your home is keeping your family connected—not being
              misused.
            </p>
            <br />
            <p
              style={{
                fontWeight: '600',
                fontSize: '24px',
                color: '333333',
                lineHeight: '31px',
              }}
            >
              Ready to learn more?
            </p>
            <br />
            Sign up for an Expert Session on Connected Home and Parental Control.
          </div>
        ),
        testimonials: [
          {
            text: CustomerSay,
          },
        ],
        imageSrc: ParentalControl,
      },
      bookingModal: {
        title: 'Schedule Your Connected Home & Parental Control Consultation',
      },
    },
    {
      category: 'Digital Life',
      megaUseCase: megaUseCases.productsetup,
      vhtSegment: undefined,
      isPopular: true,
      tile: {
        title: 'Product Setup and Feature Overview',
        text:
          'Setting up a new product can feel like a chore. There are so many features, and it can be hard to know if you might be missing out on something. We want to help you get your devices set up correctly the first time, so you never have to wonder if you’re getting the most that your products have to offer.',
        imageSrc: ProductSetup,
      },
      details: {
        title: 'Product Setup and Feature Overview',
        text: (
          <div>
            Setting up a new product can feel like a chore. There are so many features, and it can be hard to know if
            you might be missing out on something. We want to help you get your devices set up correctly the first time,
            so you never have to wonder if you’re getting the most that your products have to offer.
            <br />
            <br />
            <p style={{ fontSize: '24px', fontWeight: '600', lineHeight: '31px' }}>
              In this one-on-one Expert Session, we’ll help you get your gear set up, by:
            </p>
            <br />
            {ProductSetupAndFeatureOverviewPoints.items.map((item) => {
              return (
                <div className="points" key={item.key}>
                  <div className="points__svg">{item.svg(pointsStyles)}</div>
                  <p>{item.text}</p>
                </div>
              );
            })}
            <br />
            <p
              style={{
                fontWeight: '600',
                fontSize: '24px',
                color: '333333',
                lineHeight: '31px',
              }}
            >
              Ready to learn more?
            </p>
            <br />
            Book an Expert Session for Product Setup and Feature Overview.
          </div>
        ),
        testimonials: [
          {
            text: CustomerSay,
          },
        ],
        imageSrc: ProductSetup,
      },
      bookingModal: {
        title: 'Schedule Your Product Setup and Feature Overview',
      },
    },
    {
      category: 'Security',
      megaUseCase: megaUseCases.passwordmanagement,
      vhtSegment: undefined,
      isPopular: true,
      tile: {
        title: 'Password Management',
        text:
          'It seems like every service, these days, requires a new password. Eventually you can find yourself recycling the same three passwords and always forgetting which one to use for each service. Is it really sustainable to juggle all of these passwords? Could you be putting your personal information at risk?',
        imageSrc: PasswordManagement,
      },
      details: {
        title: 'Password Management',
        text: (
          <div>
            It seems like every service, these days, requires a new password. Eventually you can find yourself recycling
            the same three passwords and always forgetting which one to use for each service. Is it really sustainable
            to juggle all of these passwords? Could you be putting your personal information at risk?
            <br />
            <br />
            <p style={{ fontSize: '24px', fontWeight: '600', lineHeight: '31px' }}>
              We can help make sure that passwords no longer have to get in the way of your enjoyment of the web, by:
            </p>
            <br />
            {PasswordManagementPoints.items.map((item) => {
              return (
                <div className="points" key={item.key}>
                  <div className="points__svg">{item.svg(pointsStyles)}</div>
                  <p>{item.text}</p>
                </div>
              );
            })}
            <br />
            <p
              style={{
                fontWeight: '600',
                fontSize: '24px',
                color: '333333',
                lineHeight: '31px',
              }}
            >
              Ready to learn more?
            </p>
            <br />
            Book an Expert Session for Password Management.
          </div>
        ),
        testimonials: [
          {
            text: CustomerSay,
          },
        ],
        imageSrc: PasswordManagement,
      },
      bookingModal: {
        title: 'Schedule Your Password Management Review',
      },
    },
    {
      category: 'Digital Life',
      megaUseCase: megaUseCases.productguidance,
      vhtSegment: undefined,
      isPopular: true,
      tile: {
        title: 'Product Purchase Guidance',
        text:
          'Quality tech equipment isn’t cheap, and there are often a lot of options to choose from, so how do you know which items are right for you? We want to make sure you feel 100% confident when you’re deciding which products to purchase for you and your household.',
        imageSrc: ProductPurchase,
      },
      details: {
        title: 'Product Purchase Guidance',
        text: (
          <div>
            Quality tech equipment isn’t cheap, and there are often a lot of options to choose from, so how do you know
            which items are right for you? We want to make sure you feel 100% confident when you’re deciding which
            products to purchase for you and your household.
            <br />
            <br />
            <p style={{ fontSize: '24px', fontWeight: '600', lineHeight: '31px' }}>
              Our experts will provide one-on-one guidance to you, so you can feel comfortable with the products that
              you choose to buy, by:
            </p>
            <br />
            {ProductPurchaseGuidancePoints.items.map((item) => {
              return (
                <div className="points" key={item.key}>
                  <div className="points__svg">{item.svg(pointsStyles)}</div>
                  <p>{item.text}</p>
                </div>
              );
            })}
            <br />
            <p
              style={{
                fontWeight: '600',
                fontSize: '24px',
                color: '333333',
                lineHeight: '31px',
              }}
            >
              Ready to learn more?
            </p>
            <br />
            Book an Expert Session for Product Purchase Guidance.
          </div>
        ),
        testimonials: [
          {
            text: CustomerSay,
          },
        ],
        imageSrc: ProductPurchase,
      },
      bookingModal: {
        title: 'Schedule Your Product Purchase Guidance',
      },
    },
    {
      category: 'Digital Life',
      megaUseCase: megaUseCases.wifievaluation,
      vhtSegment: undefined,
      isPopular: true,
      tile: {
        title: 'Wi-Fi Evaluation',
        text:
          'It’s dificult to think of anything more frustrating than an unstable internet connection. Do you ever find that one minute, it’s working fine, but the next, you can’t load any webpages, stream your favorite shows, or send and receive emails; or is there just that one room in your house that doesn’t get a Wi-Fi signal?',
        imageSrc: WifiEval,
      },
      details: {
        title: 'Wi-Fi Evaluation',
        text: (
          <div>
            It’s dificult to think of anything more frustrating than an unstable internet connection. Do you ever find
            that one minute, it’s working fine, but the next, you can’t load any webpages, stream your favorite shows,
            or send and receive emails; or is there just that one room in your house that doesn’t get a Wi-Fi signal?
            <br />
            <br />
            <p style={{ fontSize: '24px', fontWeight: '600', lineHeight: '31px' }}>
              Our team can work with you, one-on-one, to make sure your home internet is optimized for you by:
            </p>
            <br />
            {WiFiEvaluationPoints.items.map((item) => {
              return (
                <div className="points" key={item.key}>
                  <div className="points__svg">{item.svg(pointsStyles)}</div>
                  <p>{item.text}</p>
                </div>
              );
            })}
            <br />
            <p
              style={{
                fontWeight: '600',
                fontSize: '24px',
                color: '333333',
                lineHeight: '31px',
              }}
            >
              Ready to learn more?
            </p>
            <br />
            Book an Expert Session for WiFi Evaluation.
          </div>
        ),
        testimonials: [
          {
            text: CustomerSay,
          },
        ],
        imageSrc: WifiEval,
      },
      bookingModal: {
        title: 'Schedule Your Wi-Fi Evaluation',
      },
    },
    {
      category: 'Other',
      megaUseCase: megaUseCases.customappointment,
      vhtSegment: undefined,
      isPopular: false,
      tile: {
        title: 'Custom Appointment',
        text:
          'Do you have some questions about any household technology, but don’t feel like it fits into any of the other categories? Or are you considering purchasing a new piece of technology, but want to discuss it with an expert first? Not a problem! Set up a custom appointment and an expert will call you to answer any questions you may have.',
        imageSrc: CustomAppt,
      },
      details: {
        title: 'Custom Appointment',
        text: (
          <div>
            Do you have some questions about any household technology, but don’t feel like it fits into any of the other
            categories? Or are you considering purchasing a new piece of technology, but want to discuss it with an
            expert first? Not a problem! Set up a custom appointment and an expert will call you to answer any questions
            you may have.
            <br />
            <br />
            <p style={{ fontSize: '24px', fontWeight: '600', lineHeight: '31px' }}>
              In this one-on-one session, we’ll answer any questions you may have about the technology in your life
              including:
            </p>
            <br />
            {CustomAppointmentPoints.items.map((item) => {
              return (
                <div className="points" key={item.key}>
                  <div className="points__svg">{item.svg(pointsStyles)}</div>
                  <p>{item.text}</p>
                </div>
              );
            })}
            <br />
            <p
              style={{
                fontWeight: '600',
                fontSize: '24px',
                color: '333333',
                lineHeight: '31px',
              }}
            >
              Ready to learn more?
            </p>
            <br />
            Book an Expert Session for a Custom Appointment.
          </div>
        ),
        testimonials: [
          {
            text: CustomerSay,
          },
        ],
        imageSrc: CustomAppt,
      },
      bookingModal: {
        title: 'Schedule Your Custom Appointment',
      },
    },
  ],
};

export default SHS_WEB_experiencesDataArray;

SafeConsole.log('SHS_WEB_experiencesDataArray version 2 = ', SHS_WEB_experiencesDataArray);



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/components/experiences/Data/ExperiencesV2.SHS-WEB.js